const corners = [
  { pos: "top-3 left-3", border: "border-t border-l" },
  { pos: "top-3 right-3", border: "border-t border-r" },
  { pos: "bottom-3 left-3", border: "border-b border-l" },
  { pos: "bottom-3 right-3", border: "border-b border-r" },
];

/* No filters, no extra decorative lines */
const TargetingReticle = () => (
  <div data-testid="targeting-reticle" className="absolute inset-0 z-20 pointer-events-none">
    {corners.map((c, i) => (
      <div
        key={i}
        data-testid={`reticle-corner-${i}`}
        className={`absolute ${c.pos} ${c.border} w-6 h-6 md:w-8 md:h-8 border-cyan-500/30`}
      />
    ))}
  </div>
);

export default TargetingReticle;
